export const formatNumberWithCommas = (value, options = {}) => {
    const { emptyZero = false } = options;
    if (value == null || value === "") return "";
    const num = Number(value);
    if (!Number.isFinite(num)) return "";
    if (emptyZero && num === 0) return "";
    const sign = num < 0 ? "-" : "";
    return `${sign}${Math.abs(num).toLocaleString("ko-KR")}`;
};

export const parseNumericInput = (raw) => {
    const digits = String(raw ?? "").replace(/[^0-9]/g, "");
    return digits ? Number(digits) : "";
};

export const toNumericInputState = (raw, options = {}) => {
    const value = parseNumericInput(raw);
    return {
        value,
        display: formatNumberWithCommas(value, options),
    };
};

export const formatKrw = (value) => {
    if (value == null) return "—";
    return `${formatNumberWithCommas(value)}원`;
};

/**
 * 퍼센트 표시 — 3자리마다 콤마, 소수점 자릿수 지정
 *  formatPercent(25646)        → "25,646.0%"
 *  formatPercent(-78.9)        → "-78.9%"
 *  formatPercent(78.9, 1, true)→ "+78.9%"  (양수에 + 부호)
 */
export const formatPercent = (value, decimals = 1, showPlus = false) => {
    if (value == null) return "";
    const num = Number(value);
    if (!Number.isFinite(num)) return "";
    const formatted = num.toLocaleString("ko-KR", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
    const sign = showPlus && num > 0 ? "+" : "";
    return `${sign}${formatted}%`;
};

/**
 * 숫자 일반 표시 — 3자리마다 콤마, 소수점 자릿수 지정
 *  formatNumber(1234567.89, 2) → "1,234,567.89"
 */
export const formatNumber = (value, decimals = 0) => {
    if (value == null) return "";
    const num = Number(value);
    if (!Number.isFinite(num)) return "";
    return num.toLocaleString("ko-KR", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};

export const formatCompactKrw = (value) => {
    if (value == null) return "—";
    const num = Number(value);
    if (!Number.isFinite(num)) return "—";
    const sign = num < 0 ? "-" : "";
    const abs = Math.abs(num);
    if (abs >= 1_0000_0000) return `${sign}${(abs / 1_0000_0000).toFixed(1)}억`;
    if (abs >= 1000_0000) return `${sign}${(abs / 1000_0000).toFixed(0)}천만`;
    if (abs >= 1_0000) return `${sign}${(abs / 1_0000).toFixed(0)}만`;
    return `${sign}${formatNumberWithCommas(abs)}`;
};

/**
 * 파일 크기 표시 — 앱 공통. 예: 800 → "800 B", 2048 → "2.0 KB", 5_242_880 → "5.0 MB".
 *
 * <p>[왜 공통인가] 예전엔 fmtSize/formatBytes/formatSize/formatFileSize 같은 이름으로
 * 메일·채널·피드백·결재·재무·캘린더에 <b>13벌</b>이 복붙돼 있었고, 공백 유무("1.0KB" vs "1.0 KB")·
 * 소수 자릿수(MB 1자리 vs 2자리)·빈값 처리("" vs "-" vs "0B")가 파일마다 미묘하게 달랐다. 하나로 모아
 * 표기를 통일한다(공백 있음 · 소수 1자리 · B/KB/MB/GB · null·0·비수치 → "").
 *
 * @param {number|null|undefined} bytes
 * @param {string} [empty=""] 값이 없을 때 반환할 문자열(표 셀에서 "-" 를 원하면 지정).
 */
export const formatFileSize = (bytes, empty = "") => {
    if (bytes == null || bytes === "" || !Number.isFinite(Number(bytes)) || Number(bytes) <= 0) return empty;
    const n = Number(bytes);
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
    return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};
